import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const PowPointIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M22.0231 2.875C22.2147 2.87447 22.4045 2.91196 22.5815 2.98529C22.7586 3.05861 22.9193 3.16633 23.0544 3.30219L28.6875 8.93531C28.8233 9.07043 28.931 9.23114 29.0044 9.40815C29.0777 9.58517 29.1152 9.77496 29.1147 9.96656V27.6666C29.1147 28.4709 28.4538 29.125 27.6416 29.125H8.34812C7.53562 29.125 6.875 28.4709 6.875 27.6666V4.33344C6.875 3.52906 7.53594 2.875 8.34812 2.875H22.0231ZM22.0231 2H8.34812C7.05125 2 6 3.04469 6 4.33344V27.6666C6 28.9553 7.05125 30 8.34812 30H27.6416C28.9384 30 29.9897 28.9553 29.9897 27.6666V9.96656C29.9896 9.34771 29.7438 8.75421 29.3062 8.31656L23.6731 2.68344C23.2355 2.24592 22.642 2.0001 22.0231 2Z"
        fill="currentColor"
      />
      <path
        d="M22 2V7.33344C22.0001 8.04063 22.281 8.71883 22.7811 9.21889C23.2812 9.71895 23.9594 9.99992 24.6666 10H30L22 2Z"
        fill="currentColor"
      />
      <path
        d="M3.33333 24.3333H14C14.3536 24.3333 14.6928 24.1929 14.9428 23.9428C15.1929 23.6928 15.3333 23.3536 15.3333 23V12.3333C15.3333 11.9797 15.1929 11.6406 14.9428 11.3905C14.6928 11.1405 14.3536 11 14 11H3.33333C2.97971 11 2.64057 11.1405 2.39052 11.3905C2.14048 11.6406 2 11.9797 2 12.3333V23C2 23.3536 2.14048 23.6928 2.39052 23.9428C2.64057 24.1929 2.97971 24.3333 3.33333 24.3333Z"
        fill="currentColor"
      />
      <path
        d="M9.1 13H6V22H7.925V18.9H8.925C10 18.9 10.85 18.625 11.475 18.05C12.1 17.5 12.425 16.75 12.425 15.85C12.425 13.95 11.3 13 9.1 13ZM8.75 17.35H7.925V14.55H8.75C9.8 14.55 10.325 15 10.325 15.925C10.325 16.9 9.8 17.35 8.75 17.35Z"
        fill="white"
      />
      <path
        d="M18 20.9931H25.0035V21.9827H18V20.9931ZM18 22.9914H25.0035V24H18V22.9914ZM21.0069 14.0087C19.3512 14.0087 18 15.3599 18 17.0156C18 18.6713 19.3512 20.0225 21.0069 20.0225C22.6626 20.0225 24.0138 18.6713 24.0138 17.0156H21.0069V14.0087Z"
        fill="currentColor"
      />
      <path
        d="M21.9966 13V16.0069H25.0035C25.0035 14.3512 23.6523 13 21.9966 13Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(PowPointIcon);
